import { addSeconds, format } from 'date-fns'

// format seconds to mm:ss
export default function formatTime(seconds: number): string {
  const helperDate = addSeconds(new Date(0), seconds)
  return format(helperDate, 'mm:ss')
}
